import { INTERNAL_CURRENCY_CODE } from './constants';

export namespace Configuration {
  export const SYMBOLS: Record<string, string> = {
    'ARS': '$',
    'BRL': 'R$',
    'BTC': '₿',
    'BYN': 'Br',
    'EUR': '€',
    'KZT': '₸',
    'MDL': 'L',
    'RUB': '₽',
    'TRY': '₺',
    'UAH': '₴',
    'USD': 'C',
    'UZS': 'U',
    [INTERNAL_CURRENCY_CODE]: 'CS'
  };

  export const DIGITS_INFO: Record<string, string> = {
    'BTC': '1.0-8'
  };

  export const DEFAULT_DIGITS_INFO = '1.0-2';

  export const DEFAULT_ANIMATION_DURATION = 550;
}
